<template>
  <div class="recruit-notice">
    <h1>招生公告</h1>
    <h3>2022暑期工作坊介绍</h3>
    <p>
      为服务数字人文前沿研究需求，北京大学数字人文中心与北京大学人工智能研究院将于
      7 月 18 日至 7 月 30 日启动 2022
      年度"数字人文暑期工作坊"。课程将邀请国内外数字人文领域的高水平学者，引导学员运用数字人文的研究范式，思考并解决人文社科的研究问题。课程将招收文史哲、艺术、考古、人工智能、计算语言、软件工程等多学科背景的学员，在讲授之外组织跨学科研讨和研究实践，培养既具备人文素养又掌握信息技术技能的跨学科人才。
    </p>
    <h3>项目内容</h3>
    <p>
      采取“导师主讲+项目实践”相结合模式。课堂教学部分包括数字人文理论与技术基础。&gt;采取“导师主讲+项目实践”相结合模式。课堂教学部分包括数字人文理论与技术基础。
    </p>
    <h4>理论部分：</h4>
    <li>人文计算与数字人文</li>
    <li>数字人文平台及数据库</li>
    <li>数字人文中的定量分析方法</li>
    <li>本体应用</li>
    <li>文本分析与挖掘</li>
    <li>社会网络分析与可视化分析等</li>
    <h4>技术部分：</h4>
    <li>R 语言文本分析专题</li>
    <p>
      在课程项目实践中，工作坊学员将结成 4-5
      人小组，围绕研究问题，在项目导师指导下合作完成学术项目实践与展示。
    </p>
    <h3>招生对象</h3>
    <p>
      招生对象为国内外对数字人文领域的发展和研究感兴趣的高校硕士、博士研究生，同时鼓励少量对数字人文领域有深厚兴趣，有志于从事相关研究学习的优秀高年级本科生参加学习。课程将同时招收两方面的学员：
    </p>
    <li>人文领域，如文学、历史、哲学、古典文献等；</li>
    <li>人工智能相关方向，如自然语言处理、深度学习、知识工程等。</li>
    <p>本次工作坊计划招收学员本次工作坊计划招收学员 30 人左右。</p>
    <h3>授课时间</h3>
    <p>
      7 月 18 日 - 7 月 30 日, 共 2 周。其中集中授课时间为 7 月 18-26
      日，其他时段以 4-5
      人小组为单位，在项目导师的指导下展开项目实践，在真实材料上解决真实问题。
    </p>
    <p>课程机会宝贵，席位有限。申请者须保证有两周时间密集参与，请慎重申请。</p>
    <h3>课程安排</h3>
    <figure class="wp-block-image is-resized">
      <img
        loading="lazy"
        src="@/assets/workshop2022.png"
        alt=""
        class="wp-image-120"
        width="735"
        height="382"
      />
    </figure>
    <h3>举办形式</h3>
    <p>
      本次工作坊以线下为优先安排，如果遇到疫情防控要求，或改为线上举办。为保证授课质量，本课程仅限正式录取学员参加，授课内容不对外开放。
    </p>
    <h3>报名方式及提交材料</h3>
    <p>学员选拔采取自愿报名、学术指导团队遴选录取的方式。</p>
    <p>报名需提交材料：</p>
    <li>个人简历一页;</li>
    <li>
      为什么选修本课程的个人陈述一页，其中应包含自己感兴趣的数字人文研究选题（例如：数字人文的文学研究；量化历史与数字方志；数字人文与空间人文；文化分析；数字人文与观念史等），选题说明限
      500 字以内。
    </li>
    <p>
      联系人：齐老师，邮箱：gdhc@pku.edu.cn。报名邮件标题为“2022
      暑期工作坊报名+学校+姓名”
    </p>
    <p>
      报名截止时间为 2022 年 6 月 19 日，录取通知将于 7 月 3
      日前分批发至学员邮箱。
    </p>
    <h3>成果发表及保护</h3>
    <p>
      暑期课期间产出的有潜力的研究成果，课程导师将指导项目小组继续完善，并推荐到相关期刊发表。正式论文发表应标注北京大学数字人文研究中心的贡献，且成果不得与非工作坊成员共享。本课程提供的所有材料，包括：课件、数据和研究选题等需与课程方签署保护协议。
    </p>
    <h3>学员费用</h3>
    <p>本次工作坊不收取学费。</p>
    <h3>结业方式</h3>
    <p>
      完成课程并考核合格者，可获得北京大学研究生院颁发的暑期学校结业证书。对有深入研究兴趣者将支持其继续参与或开展数字人文方面的研究项目。
    </p>
    <h3>博士申请推荐</h3>
    <p>
      课程将选拔表现优秀的学员申请 2023
      年北京大学数字人文方向博士生；有意申请其它高校相关方向博士研究者，我们将出具推荐信。
    </p>
  </div>
</template>

<script>
export default {
  name: "RecruitNotice",
};
</script>

<style lang="less" scoped>
.recruit-notice {
  padding: 1rem 0;
  h1 {
    text-align: center;
    letter-spacing: 0.4rem;
    font-weight: normal;
    margin: 0 0 1rem;
  }
  h4,
  p {
    margin: 0.3rem 0;
    line-height: 1.2rem;
    letter-spacing: 0.04rem;
  }
  li {
    line-height: 1.2rem;
    letter-spacing: 0.04rem;
  }

  h3 {
    margin: 1rem 0 0.3rem;
  }
}
</style>
